import request from '@/utils/request';
import Vue from 'vue';

//创建 
export function visaCreate(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/create`,
    data: params
  });
}
//删除
export function visaDelete(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/delete/${params}`
  });
}
//详情 
export function visaGetDetailByBid(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/getDetailByBid/${params}`
  });
}
//上架
export function visaGrounding(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/grounding`,
    data: params
  });
}
//列表 
export function visaQuery(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/query`,
    data: params
  });
}
//下架
export function visaUndercarriage(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/undercarriage`,
    data: params
  });
}
//更新
export function visaUpdate(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/update`,
    data: params
  });
}
//所有领区  
export function getAllConsularDistrict() {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/flavor/getByType/consular_district`
  });
}
export function getByTypeEntries() {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/flavor/getByType/entries`
  });
}

export function getAllElectronicForms() {
  return request({
    method: 'get',
    url: `${Vue.prototype.$conf.visaService}/electronicForm/getAllElectronicForms`
  });
}
//   
export function getRepulseRecords(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/orderMgr/getRepulseRecords`,
    data: params
  });
}

export function moveUp(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/moveUp/` + params
  });
}

export function moveDown(params) {
  return request({
    method: 'post',
    url: `${Vue.prototype.$conf.visaService}/visa/moveDown/` + params
  });
}